export default {
    data() {
        return {
            moduleName: 'blackoutContents',
            detailPageRouteName: 'blackoutContentDetail',
            entity: {
                enabled: { global: true},
                enabled_override: {},
                id_operator: 0,
                name: null,
                from_timestamp: null,
                to_timestamp: null,
                id_epg: null,
                reason: null,
                reflect_overlaps: false,
                allow_catchup: false,
                allow_ts: false,
                allow_pvr: false,
                allowed_regions: [],
                restricted_regions: [],
            },
            updateFields: [
                'enabled',
                'name',
                'enabled_override',
                'id_operator',
                'from_timestamp',
                'to_timestamp',
                'id_epg',
                'reason',
                'reflect_overlaps',
                'allow_catchup',
                'allow_ts',
                'allow_pvr',
                'allowed_regions',
                'restricted_regions',
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/views/blackoutContents/mixins/blackoutContents.js